'use client';
import React, { useState, useRef } from 'react';
import Image from 'next/image';
import Skeleton from './Skeleton';

const LazyImage = ({ 
  src, 
  alt, 
  width, 
  height, 
  className = '', 
  priority = false,
  skeletonClassName = '',
  trackPerformance = false,
  ...props 
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const startTimeRef = useRef(performance.now());

  const handleLoad = () => {
    setIsLoading(false);
    
    if (trackPerformance) {
      const loadTime = performance.now() - startTimeRef.current;
      console.log(`Image loaded: ${src} in ${loadTime.toFixed(2)}ms`);
    }
  };

  const handleError = () => {
    setIsLoading(false);
    setHasError(true);
    
    if (trackPerformance) {
      console.warn(`Failed to load image: ${src}`);
    }
  };

  return (
    <div data-component-id="src/components/ui/LazyImage.jsx:40:4" data-component-path="src/components/ui/LazyImage.jsx" data-component-line="40" data-component-end-line="69" data-component-file="LazyImage.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%22%7D" className="relative" style={{ width, height }}>
      {isLoading && (
        <Skeleton data-component-id="src/components/ui/LazyImage.jsx:42:8" data-component-path="src/components/ui/LazyImage.jsx" data-component-line="42" data-component-end-line="45" data-component-file="LazyImage.jsx" data-component-name="Skeleton" data-component-content="%7B%22elementName%22%3A%22Skeleton%22%7D" 
          className={`absolute inset-0 ${skeletonClassName}`}
          style={{ width, height }}
        />
      )}
      
      {hasError ? (
        <div data-component-id="src/components/ui/LazyImage.jsx:49:8" data-component-path="src/components/ui/LazyImage.jsx" data-component-line="49" data-component-end-line="54" data-component-file="LazyImage.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22textContent%22%3A%22Failed%20to%20load%22%7D" 
          className={`flex items-center justify-center bg-gray-100 text-gray-400 text-xs ${className} fade-in`}
          style={{ width, height }}
        >
          Failed to load
        </div>
      ) : (
        <Image data-component-id="src/components/ui/LazyImage.jsx:56:8" data-component-path="src/components/ui/LazyImage.jsx" data-component-line="56" data-component-end-line="67" data-component-file="LazyImage.jsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%5Bvar%3Asrc%5D%22%2C%22alt%22%3A%22%5Bvar%3Aalt%5D%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
          src={src}
          alt={alt}
          width={width}
          height={height}
          className={`${className} ${isLoading ? 'opacity-0' : 'opacity-100 fade-in'} transition-opacity duration-300 will-change-opacity`}
          onLoad={handleLoad}
          onError={handleError}
          priority={priority}
          loading={priority ? undefined : 'lazy'}
          {...props}
        />
      )}
    </div>
  );
};

export default LazyImage;
